<template>
  <div :class="shellClass">
    <div :class="bodyClass">
      <div :class="contentClass">
        <div class="filter-bar-row">
          <slot />
        </div>

        <div v-if="$slots.actions" class="filter-bar-actions">
          <slot name="actions" />
        </div>
      </div>

      <div v-if="$slots.searchActions" class="mt-3 flex flex-wrap items-center justify-end gap-2">
        <slot name="searchActions" />
      </div>

      <div v-if="$slots.extra" class="mt-3">
        <slot name="extra" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  shellClass: {
    type: String,
    default: 'filter-bar-shell is-compact'
  },
  bodyClass: {
    type: String,
    default: 'filter-bar-body is-compact'
  },
  contentClass: {
    type: String,
    default: 'filter-bar-content'
  }
})

const shellClass = computed(() => props.shellClass)
const bodyClass = computed(() => props.bodyClass)
const contentClass = computed(() => props.contentClass)
</script>
